module.exports = __webpack_public_path__ + "img/unicorn-book_B09GZR78XL.541c5836.jpg";